import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import ReactJson from '@microlink/react-json-view';
import { useTranslation } from 'react-i18next';
import { Button } from '@totalsoft/rocket-ui';

const EditJsonContentDialog = props => {
  const { open, content, onChange, onClose, onCancel, onConfirm, inputProps } = props;
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} fullScreen={inputProps ? inputProps.fullScreen : false}>
      <DialogTitle id='scroll-dialog-title'>{t('JsonFileContent.EditJsonTitle')}</DialogTitle>
      <DialogContent dividers={true}>
        <ReactJson
          id='themeJson'
          name={'theme'}
          src={content}
          theme='shapeshifter:inverted'
          indentWidth={2}
          onEdit={onChange}
          onAdd={onChange}
          onDelete={onChange}
          enableClipboard={true}
        />
      </DialogContent>
      <DialogActions>
        <Button id='btnJsConfirm' onClick={onConfirm} color='primary'>
          {t('JsonFileContent.Confirm')}
        </Button>
        <Button id='btnJsCancel' onClick={onCancel} color='primary'>
          {t('JsonFileContent.Cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

EditJsonContentDialog.propTypes = {
  t: PropTypes.func.isRequired,
  open: PropTypes.bool,
  content: PropTypes.array,
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  inputProps: PropTypes.object
};

export default React.memo(EditJsonContentDialog);
